import * as fs from "../utils/formStateUtils";

/* 행 순서를 배열 인덱스 기준으로 다시 재부여 */
export const normalizeRowOrders = (structure) => ({
  ...structure,
  pages: structure.pages.map((p) => ({
    ...p,
    sections: p.sections.map((s) => ({
      ...s,
      rows: s.rows.map((r, idx) => ({ ...r, order: idx + 1 })),
    })),
  })),
});

/* 행 추가 */
export const addRow = (formStructure, sectionId, layout = "full") => {
  if (!formStructure) return formStructure;

  // 해당 섹션의 다음 order 계산 (기존 최대 + 1)
  const section = fs.findElementInFormStructure(
    formStructure,
    "section",
    sectionId
  );
  const nextOrder =
    (section?.rows?.reduce(
      (max, r) => (r.order && r.order > max ? r.order : max),
      0
    ) || 0) + 1;

  const newRow = {
    id: `row_${Date.now()}_${Math.floor(Math.random() * 1000)}`,
    layout,
    fields: [],
    order: nextOrder,
  }; // row object

  return fs.addRowToSection(formStructure, sectionId, newRow);
};

/* 행 삭제 */
export const deleteRow = fs.deleteRow;

/* 행 레이아웃 업데이트 */
export const updateRowLayout = fs.updateRowLayout;

/* 행 이동 */
export const moveRow = fs.moveRow;

/* 특정 행이 속한 섹션 ID 찾기 */
export const findSectionIdForRow = fs.findSectionIdForRow;
